import { createContext, useContext } from 'react';

import { type CashbackCalculatorContextState } from '../types';

const CashbackCalculatorContext =
  createContext<Nullable<CashbackCalculatorContextState>>(null);

const useCashbackCalculatorContext = () => {
  const context = useContext(CashbackCalculatorContext);
  if (!context) {
    throw new Error(
      'useCashbackCalculatorContext must be used within a CashbackCalculatorProvider'
    );
  }
  return context;
};

export { CashbackCalculatorContext, useCashbackCalculatorContext };
